import { useEffect, useState } from "react";
import { Layout } from "../../../../ui/layout";
import { CustomHorizontalTab } from "../../../../ui/organisms/customHorizontalTab";
import { MenuItems } from "../../../../ui/organisms/navbar/dto";
import { InspectionVisitBlocksEdit } from "./blocks";
import { InspectionVisitEditRight } from "./right";
import { useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left";
import { IVGestioneControlloEdit } from "./gestioneControllo/forms";
import Button from "../../../../ui/molecules/button";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { InspectionVisitUpdate, resetInspectionVisitUpdateStatus, resetRCAUpdateSatus } from "../../slice";
import { IVGestionePrelieviEdit } from "./gestionePrelievi/list";
import { resetSampleCollectionCreationStatus, resetSampleCollectionUpdateStatus } from "./gestionePrelievi/slice";
import { IVGestioneRimborsiEdit } from "./gestioneRimborsi";
import { resetReimbursementCreationStatus } from "./gestioneRimborsi/slice";

export function InspectionVisitEdit() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const assignmentState = useAppSelector(state => state.assignment)
    const sampleCollectionState = useAppSelector(state => state.sampleCollection)
    const reimbursementState = useAppSelector(state => state.reimbursement)
    const [selectedTab, setSelectedTab] = useState<number>(0)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)

    useEffect(() => {
        if (assignmentState.inspectionVisitUpdateStatus === 'successfully') {
            dispatch(resetInspectionVisitUpdateStatus())
            setShowSuccess(true)
        }
    }, [assignmentState.inspectionVisitUpdateStatus])

    useEffect(() => {
        if (sampleCollectionState.sampleCollectionCreationStatus === 'successfully') {
            dispatch(resetSampleCollectionCreationStatus())
            setShowSuccess(true)
        }
    }, [sampleCollectionState.sampleCollectionCreationStatus])

    useEffect(() => {
        if (sampleCollectionState.sampleCollectionUpdateStatus === 'successfully') {
            dispatch(resetSampleCollectionUpdateStatus())
            setShowSuccess(true)
        }
    }, [sampleCollectionState.sampleCollectionUpdateStatus])

    // useEffect(() => {
    //     if (reimbursementState.reimbursementCreationStatus === 'successfully') {
    //         dispatch(resetReimbursementCreationStatus())
    //         setShowSuccess(true)
    //     }
    // }, [reimbursementState.reimbursementCreationStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
    }, [showSuccess])

    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Gestione Incarico', 'Dettaglio Visita Ispettiva']}
            onScrollTop={assignmentState.inspectionVisitUpdateStatus === 'successfully'}
            noPaddingLat
            headerLabel="Gestione Incarichi"
            headerChildren={
                <div className="text-left flex flex-row justify-end" style={{ padding: '16px', justifyContent: 'end' }}>
                    <Button size={"sm"} iconPosition={"off"} variant={"solid"} label="Salva" color={"orange"}
                        onClick={() => {
                            dispatch(InspectionVisitUpdate({ body: assignmentState.inspectionVisitUpdateRequest, id: assignmentState.inspectionVisitIdToUpdate }))
                        }}
                    />
                </div>
            }
            headerIcon={
                <button style={{ paddingTop: '12px' }} onClick={() => {
                    navigate('/modificaIncarico')
                }}>
                    <ArrowLeftIcon />
                </button>
            }
        >
            <CustomHorizontalTab
                selectedIndex={selectedTab}
                onTabClick={(index) => setSelectedTab(index)}
            >
                <div>Gestione Controllo</div>
                <div>Gestione Prelievo</div>
                <div>Documentazione</div>
                <div>Gestione Rimborsi</div>
            </CustomHorizontalTab>

            <div style={{ display: 'flex', gap: '12px', minHeight: window.innerHeight }}>
                <div style={{ flex: '0.7' }}>
                    <div className="fieldset bg-brandPrimary-200">
                        {
                            showSuccess &&
                            <div className="gap-[8px] text-left" style={{ margin: '24px', borderRadius: '12px', backgroundColor: '#D1F5D9', borderColor: '#8AE59F', borderWidth: 2 }}>
                                <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                                    Dati salvati correttamente.
                                </span>
                            </div>
                        }
                        {
                            selectedTab === 0 &&
                            <IVGestioneControlloEdit />
                        }
                        {
                            selectedTab === 1 &&
                            <IVGestionePrelieviEdit />
                        }
                        {
                            selectedTab === 2 &&
                            <InspectionVisitBlocksEdit />
                        }
                        {
                            selectedTab === 3 &&
                            <IVGestioneRimborsiEdit />
                        }
                    </div>
                </div>

                <div style={{ flex: '0.3' }}>
                    <InspectionVisitEditRight />
                </div>
            </div>
        </Layout>
    )
}